import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PlanServices from '../../../services/PlanServices';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';  // Import react-select

function AddPlan() {
  const [formValues, setFormValues] = useState({
    name: "",
    description: [], // Keep track of selected descriptions
    price: 0,
    validity: 0,
    packageType: "",
    status: "inactive"
  });

  const navigate = useNavigate();


  const allDescriptions = [
    { value: "Faster Data Refresh", label: "Faster Data Refresh" },
    { value: "Include all Features of OTW", label: "Include all Features of OTW" },
    { value: "Ad-free Experience", label: "Ad-free Experience" },
    { value: "Includes all scripts and indices", label: "Includes all scripts and indices" },
    { value: "No Live Webinar Access", label: "No Live Webinar Access" }
  ];

  // Handle input changes
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? (checked ? "active" : "inactive") : value,
    });
  };

  // Handle multi-select change
  const handleSelectChange = (selectedOptions) => {
    const descriptions = selectedOptions.map(option => option.value); // Get the value array from the selected options
    setFormValues({
      ...formValues,
      description: descriptions,
    });
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await PlanServices.addPlan({
        name: formValues.name,
        description: formValues.description, // Send description as an array
        price: formValues.price,
        validity: formValues.validity,
        packageType: formValues.packageType,
        status: formValues.status,
      });
      console.log(response);
      alert('Plan Added Successfully');
      navigate('/admin/plan');
      
    } catch (error) {
      console.error('Failed to add plan details', error);
      alert('Failed to add plan details');
    }
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Add Plan</h2>
        <div className="container-box-top-header-right">
          <Link className="list-banner-btn" to='/admin/plan'>Plans List</Link>
        </div>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Package Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formValues.name}
                      onChange={handleInputChange}
                      placeholder="Weekly"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Amount</label>
                    <input
                      type="number"
                      name="price"
                      className="form-control"
                      value={formValues.price}
                      onChange={handleInputChange}
                      placeholder="0"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Validity</label>
                    <input
                      type="number"
                      name="validity"
                      className="form-control"
                      value={formValues.validity}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Package Type</label>
                    <select
                      name="packageType"
                      className="form-control"
                      value={formValues.packageType}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Type</option>
                      <option value="free">Free</option>
                      <option value="paid">Paid</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Status</label>
                    <div className="barcode-range-inner-field">
                      <p>Active</p>
                      <div className="status-toggle">
                        <div className="check-box">
                          <input
                            type="checkbox"
                            name="status"
                            checked={formValues.status === "active"}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Description selection with react-select */}
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Description</label>
                    <Select
                      isMulti
                      name="description"
                      options={allDescriptions}  // Array of options
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={allDescriptions.filter(option => formValues.description.includes(option.value))} // Preselect based on current value
                      onChange={handleSelectChange} // Handle multi-select change
                    />
                  </div>
                </div>

              </div>
              <button type="submit" className="submit-green-btn">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddPlan;
